// Centralized logger.
// Debug/info suppressed in production unless REACT_APP_DEBUG=true.
// Warn/error always logged.
import { config } from "./config";

const shouldLog = config.debug || config.env === "development";

const stamp = () => new Date().toISOString().split("T")[1].replace("Z", "");

const format = (level, scope, args) => [
  `[${stamp()}] ${level} [${scope}]`,
  ...args,
];

export const createLogger = (scope = "app") => ({
  debug: (...args) => shouldLog && console.debug(...format("DEBUG", scope, args)),
  info:  (...args) => shouldLog && console.info(...format("INFO ", scope, args)),
  warn:  (...args) => console.warn(...format("WARN ", scope, args)),
  error: (...args) => console.error(...format("ERROR", scope, args)),
});

export const logger = createLogger("app");
